import React from "react";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./msalConfig";

interface AuthProviderProps {
  children: React.ReactNode;
}

/**
 * Wraps the application with the MSAL authentication provider.
 * Uses the singleton msalInstance configured in msalConfig.ts.
 */
export function AuthProvider({ children }: AuthProviderProps): React.JSX.Element {
  return (
    <MsalProvider instance={msalInstance}>
      {children}
    </MsalProvider>
  );
}
